module.exports = __webpack_public_path__ + "static/media/tt.9cde2b9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tt.svg
// module id = 271
// module chunks = 0